import { Container, ContainerCssTokens } from '@cp/ui';
import { MOBILE_BREAKPOINT_THRESHOLD, styled } from '../../theme';
import { Tokens, name } from './const';

export const ModalContainer = styled(Container, { name, slot: 'Container' })(({ theme }) => ({
  containerType: 'normal', // container-type collapse inside Dialog
  maxWidth: Tokens.ContainerWidth(ContainerCssTokens.width()),
  [theme.breakpoints.up(MOBILE_BREAKPOINT_THRESHOLD)]: {
    [ContainerCssTokens.offset]: Tokens.ContainerOffset('0px'),
  },
}));
